export default __webpack_public_path__ + "static/media/cartes_bancaires.52ac1180.svg";